import { grade10Part1 } from './data-part1';
import { grade10Part2 } from './data-part2';
import { grade10Part3 } from './data-part3';
import { grade10Part4 } from './data-part4';
import { grade10Part5 } from './data-part5';
import { grade10Part6 } from './data-part6';

export const grade10Data = [
  ...grade10Part1,
  ...grade10Part2,
  ...grade10Part3,
  ...grade10Part4,
  ...grade10Part5,
  ...grade10Part6
];